import { render, staticRenderFns } from "./nl.vue?vue&type=template&id=e2060672&scoped=true&"
import script from "./nl.vue?vue&type=script&lang=js&"
export * from "./nl.vue?vue&type=script&lang=js&"
import style0 from "./nl.vue?vue&type=style&index=0&id=e2060672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2060672",
  null
  
)

export default component.exports